module.exports = __webpack_public_path__ + "static/img/bac.39694d02.jpg";